import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import EnumSelect from 'components/field/EnumSelect';
import IntegerInput from 'components/field/IntegerInput';
import StringInput from 'components/field/StringInput';
import SwitchInput from 'components/field/SwitchInput';
import TextArea from 'components/field/TextArea';
import TextEditor from 'components/field/TextEditor';
import FormItem from 'components/form/FormItem';

import * as S from './ProductForm.styled';

const ProductFormGroupTab = () => {
	const data = useSelector((state) => state.productGroupList);
	const fields = data[data.currentTab] ?? [];

	const [searchParams] = useSearchParams();
	const mode = searchParams.get('mode');
	const viewMode = mode === 'view';

	const formMethods = useFormContext();
	const { setValue, watch } = formMethods;

	const attributes = watch('attributes') ?? [];

	const renderFields = () => {
		const renders = [];
		fields.forEach((field) => {
			const fieldValue = attributes.find((item) => item.attributeName === field.attributeName)?.attributeValue;
			const setter = (attributeName, attributeValue) => {
				const newJSON = JSON.parse(JSON.stringify(attributes));
				let found = false;
				newJSON.forEach((item) => {
					if (item.attributeName === attributeName) {
						item.attributeValue = attributeValue;
						found = true;
					}
				});
				if (!found) newJSON.push({ attributeName, attributeValue });
				setValue('attributes', newJSON, { shouldValidate: true, shouldDirty: true });
			};

			if (field.options.length !== 0) {
				renders.push(
					<FormItem key={field.attributeID} label={field.attributeLabel} description={field.description}>
						<EnumSelect
							name={field.attributeName}
							data={field.options.map((option) => option.value)}
							value={fieldValue}
							setValue={(value) => setter(field.attributeName, value)}
							disabled={viewMode}
						/>
					</FormItem>
				);
			} else if (field.type === 'Boolean') {
				renders.push(
					<FormItem key={field.attributeID} label={field.attributeLabel} description={field.description}>
						<SwitchInput
							className="mt-3"
							formMode={mode}
							viewMode={viewMode}
							value={fieldValue}
							setValue={(val) => setter(field.attributeName, val.currentTarget.checked)}
						/>
					</FormItem>
				);
			} else if (field.type === 'Integer' || field.type === 'Number') {
				renders.push(
					<FormItem key={field.attributeID} label={field.attributeLabel} description={field.description}>
						<IntegerInput
							value={fieldValue}
							setValue={(val) => setter(field.attributeName, val)}
							allowFloat={field.type === 'Number'}
							allowNegativeValues={true}
							disabled={viewMode}
						/>
					</FormItem>
				);
			} else if (field.type === 'Text') {
				renders.push(
					<FormItem key={field.attributeID} label={field.attributeLabel} description={field.description}>
						<TextArea
							value={fieldValue}
							setValue={(val) => setter(field.attributeName, val)}
							disabled={viewMode}
						/>
					</FormItem>
				);
			} else if (field.type === 'Html') {
				renders.push(
					<FormItem key={field.attributeID} label={field.attributeLabel} description={field.description}>
						<TextEditor
							value={fieldValue}
							setValue={(val) => setter(field.attributeName, val)}
							disabled={viewMode}
						/>
					</FormItem>
				);
			} else {
				renders.push(
					<FormItem key={field.attributeID} label={field.attributeLabel} description={field.description}>
						<StringInput
							value={fieldValue}
							setValue={(val) => setter(field.attributeName, val)}
							disabled={viewMode}
						/>
					</FormItem>
				);
			}
		});
		return renders;
	};

	return <S.TabContainer>{renderFields()}</S.TabContainer>;
};

export default ProductFormGroupTab;
